/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Next_ExerciseInputs */

const en_us2_workout_next_exercise = /** @type {(inputs: Workout_Next_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next exercise`)
};

const pt_br2_workout_next_exercise = /** @type {(inputs: Workout_Next_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo exercício`)
};

const es_419_workout_next_exercise = /** @type {(inputs: Workout_Next_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente ejercicio`)
};

const pt_pt2_workout_next_exercise = /** @type {(inputs: Workout_Next_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo exercício`)
};

const fr_fr2_workout_next_exercise = /** @type {(inputs: Workout_Next_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice suivant`)
};

const de_de2_workout_next_exercise = /** @type {(inputs: Workout_Next_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Übung`)
};

const it_it2_workout_next_exercise = /** @type {(inputs: Workout_Next_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimo esercizio`)
};

/**
* | output |
* | --- |
* | "Next exercise" |
*
* @param {Workout_Next_ExerciseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_next_exercise = /** @type {((inputs?: Workout_Next_ExerciseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Next_ExerciseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_next_exercise(inputs)
	if (locale === "es-419") return es_419_workout_next_exercise(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_next_exercise(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_next_exercise(inputs)
	if (locale === "de-DE") return de_de2_workout_next_exercise(inputs)
	if (locale === "it-IT") return it_it2_workout_next_exercise(inputs)
	return en_us2_workout_next_exercise(inputs)
});
export { workout_next_exercise as "workout.next_exercise" }